export function combineUrl(
	host: string,
	path: string,
	searchParams: URLSearchParams
) {
	const url = new URL(path, host)
	url.search = searchParams.toString()

	return url
}
